{
  "COMPOSE_REDIRECT": {
    "OPENING": "Neue Unterhaltung mit {email} wird geöffnet…",
    "NO_EMAIL": "Keine E-Mail-Adresse angegeben. Verwenden Sie ?email=name@example.com",
    "CONTACT_ERROR": "Der Kontakt für {email} konnte nicht gefunden werden."
  },
  "CONVERSATION": {
    "404": "Wir können die Konversation leider nicht finden. Bitte versuche es erneut",
    "SELECT_A_CONVERSATION": "Bitte wählen Sie eine Konversation aus dem linken Bereich aus",
    "CSAT_REPLY_MESSAGE": "Bitte bewerten Sie diese Unterhaltung",
    "SWITCH_VIEW_LAYOUT": "Layout wechseln",
    "DASHBOARD_APP_TAB_MESSAGES": "Nachrichten",
    "UNVERIFIED_SESSION": "Die Identität dieses Benutzers ist nicht verifiziert",
    "NO_MESSAGE_1": "Oh oh! Anscheinend befinden sich keine Nachrichten von Kunden in Ihrem Posteingang.",
    "NO_MESSAGE_2": "um eine Nachricht an Ihre Seite zu senden!",
    "NO_INBOX_1": "Hallo! Sieht so aus, als hätten Sie noch keine Posteingänge hinzugefügt.",
    "NO_INBOX_2": " um loszulegen",
    "NO_INBOX_AGENT": "Oh oh! Sieht so aus, als wären Sie nicht Teil eines Posteingangs. Bitte wenden Sie sich an Ihren Administrator",
    "SEARCH_MESSAGES": "Nachrichten in Unterhaltungen suchen",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Übersetzung",
    "EMPTY_STATE": {
      "CMD_BAR": "zum Öffnen des Kommandomenüs",
      "KEYBOARD_SHORTCUTS": "um Tastenkürzel anzuzeigen"
    },
    "SEARCH": {
      "TITLE": "Nachrichten durchsuchen",
      "RESULT_TITLE": "Suchergebnisse",
      "LOADING_MESSAGE": "Daten werden geladen...",
      "PLACEHOLDER": "Geben Sie einen Text ein, um danach zu suchen",
      "NO_MATCHING_RESULTS": "Keine Ergebnisse gefunden."
    },
    "UNREAD_MESSAGES": "Ungelesene Nachrichten",
    "UNREAD_MESSAGE": "Ungelesene Nachricht",
    "CLICK_HERE": "Hier klicken",
    "LOADING_INBOXES": "Posteingänge laden",
    "LOADING_CONVERSATIONS": "Gespräche laden",
    "CANNOT_REPLY": "Sie können nicht antworten, weil",
    "24_HOURS_WINDOW": "24-Stunden-Nachrichtenfenster-Beschränkung",
    "NOT_ASSIGNED_TO_YOU": "Diese Konversation ist Ihnen nicht zugeordnet. Möchten Sie dieses Gespräch sich selbst zuordnen?",
    "ASSIGN_TO_ME": "Mir zuweisen",
    "TWILIO_WHATSAPP_CAN_REPLY": "Sie können auf diese Konversation nur mit einer Nachrichtenvorlage antworten wegen",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24-Stunden-Nachrichtenfenster-Beschränkung",
    "REPLYING_TO": "Sie antworten auf:",
    "REMOVE_SELECTION": "Auswahl entfernen",
    "DOWNLOAD": "Herunterladen",
    "UNKNOWN_FILE_TYPE": "Unbekannte Datei",
    "SAVE_CONTACT": "Kontakt speichern",
    "NO_CONTENT": "Kein Inhalt zum Anzeigen",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Erledigen Sie vor dem Senden:",
      "EXECUTE": "Ausführen",
      "RETRY": "Erneut versuchen",
      "CONFIRM": "Jetzt ausführen?",
      "CONFIRM_YES": "Ja, ausführen",
      "CONFIRM_NO": "Abbrechen",
      "RUNNING": "Wird ausgeführt…",
      "DONE": "Erledigt",
      "CLAIM_DELAYED": "wird nach Zustellung der Bestellung angelegt",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "NEUE Reklamation {reference} angelegt, {planned} ist geschlossen — passen Sie den Entwurfstext an",
        "NEW_CLAIM": "NEUE Reklamation {reference} angelegt, statt {planned} zu aktualisieren — passen Sie den Entwurfstext an",
        "OTHER_CLAIM": "Reklamation {reference} statt {planned} aktualisiert — passen Sie den Entwurfstext an",
        "EXISTING_CLAIM": "Keine neue Reklamation angelegt, die bestehende {reference} wurde aktualisiert — passen Sie den Entwurfstext an",
        "OTHER": "Das ist anders gelaufen, als der Entwurf annahm — passen Sie den Entwurfstext an"
      },
      "FAILED": "Fehlgeschlagen",
      "UNREACHABLE": "Der Bot ist nicht erreichbar",
      "REQUEST_FAILED": "Die Aktion konnte nicht gestartet werden, bitte versuchen Sie es erneut.",
      "ACTIONS": {
        "CANCEL_ORDER": "Bestellung stornieren",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Zahlungsart auf Nachnahme ändern",
        "CREATE_CLAIM": "Reklamation einreichen",
        "CREATE_OR_UPDATE_CLAIM": "Reklamation einreichen oder aktualisieren",
        "EXTEND_ORDER_PICKUP_DATE": "Abholfrist verlängern"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} hat einen Kontakt geteilt",
      "LOCATION": "{sender} hat einen Standort geteilt",
      "FILE": "{sender} hat eine Datei geteilt"
    },
    "UPLOADING_ATTACHMENTS": "Anhänge werden hochgeladen...",
    "REPLIED_TO_STORY": "Auf deine Geschichte geantwortet",
    "UNSUPPORTED_MESSAGE": "Diese Nachricht wird nicht unterstützt. Sie können diese Nachricht in der Facebook/Instagram-App sehen.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "Diese Nachricht wird nicht unterstützt. Sie können diese Nachricht in der Facebook-Messenger-App sehen.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "Diese Nachricht wird nicht unterstützt. Sie können diese Nachricht in der Instagram-App sehen.",
    "SUCCESS_DELETE_MESSAGE": "Nachricht erfolgreich gelöscht",
    "FAIL_DELETE_MESSSAGE": "Nachricht konnte nicht gelöscht werden! Versuchen Sie es erneut",
    "NO_RESPONSE": "Keine Antwort",
    "RESPONSE": "Antwort",
    "RATING_TITLE": "Bewertung",
    "FEEDBACK_TITLE": "Feedback",
    "REPLY_MESSAGE_NOT_FOUND": "Nachricht nicht verfügbar",
    "CARD": {
      "SHOW_LABELS": "Labels anzeigen",
      "HIDE_LABELS": "Labels ausblenden"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Fall schließen",
      "REOPEN_ACTION": "Wieder öffnen",
      "OPEN_ACTION": "Öffnen",
      "OPEN": "Mehr",
      "CLOSE": "Schließen",
      "DETAILS": "Einzelheiten",
      "SNOOZED_UNTIL": "Stummschalten bis",
      "SNOOZED_UNTIL_TOMORROW": "Schlummern bis morgen",
      "SNOOZED_UNTIL_NEXT_WEEK": "Schlummern bis nächste Woche",
      "SNOOZED_UNTIL_NEXT_REPLY": "Schlummern bis zur nächsten Antwort",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "verpasst",
        "DUE": "fällig"
      },
      "MORE": "Weitere Aktionen"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Als ausstehend markieren",
      "SNOOZE_UNTIL": "Stummschalten",
      "SNOOZE": {
        "TITLE": "Schlummern bis",
        "NEXT_REPLY": "Bei Antwort",
        "TOMORROW": "Morgen",
        "NEXT_WEEK": "Nächste Woche"
      },
      "RESOLVE_WITHOUT_CSAT": "Ohne CSAT lösen"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Stummschalten bis",
      "APPLY": "Stummschalten",
      "CANCEL": "Abbrechen"
    },
    "PRIORITY": {
      "TITLE": "Priorität",
      "OPTIONS": {
        "NONE": "Keine",
        "URGENT": "Dringend",
        "HIGH": "Hoch",
        "MEDIUM": "Mittel",
        "LOW": "Niedrig"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Keine",
        "INPUT_PLACEHOLDER": "Priorität auswählen",
        "NO_RESULTS": "Keine Ergebnisse gefunden",
        "SUCCESSFUL": "Priorität der Konversations-ID {conversationId} zu {priority} geändert",
        "FAILED": "Priorität konnte nicht geändert werden. Bitte versuchen Sie es erneut."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "In neuem Tab öffnen",
      "COPY_LINK": "Link zur Unterhaltung kopieren",
      "COPY_LINK_SUCCESS": "Link zur Unterhaltung in die Zwischenablage kopiert",
      "PENDING": "Als ausstehend markieren",
      "RESOLVED": "Als gelöst markieren",
      "MARK_AS_UNREAD": "Als ungelesen markieren",
      "MARK_AS_READ": "Als gelesen markieren",
      "REOPEN": "Konversation wieder öffnen",
      "SNOOZE": {
        "TITLE": "Erinnern",
        "NEXT_REPLY": "Bis zur nächsten Antwort",
        "TOMORROW": "Bis morgen",
        "NEXT_WEEK": "Bis nächste Woche"
      },
      "ASSIGN_AGENT": "Agent zuweisen",
      "ASSIGN_LABEL": "Label zuweisen",
      "AGENTS_LOADING": "Agenten werden geladen...",
      "ASSIGN_TEAM": "Team zuweisen",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Konversations-ID {conversationId} zugewiesen zu \"{agentName}\"",
          "FAILED": "Agent konnte nicht zugewiesen werden. Bitte versuche es erneut."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Label #{labelName} der Konversations-ID {conversationId} zugewiesen",
          "FAILED": "Label konnte nicht zugewiesen werden. Bitte versuche es erneut."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Das Team\"{team}\" wurde der Konversations-ID {conversationId} zugewiesen",
          "FAILED": "Team konnte nicht zugewiesen werden. Bitte versuche es erneut."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Nachrichten-Signatur",
      "ENABLE_SIGN_TOOLTIP": "Signatur aktivieren",
      "DISABLE_SIGN_TOOLTIP": "Signatur deaktivieren",
      "MSG_INPUT": "Umschalt + Eingabetaste für neue Zeile. Beginnen Sie mit '/', um eine vordefinierte Antwort auszuwählen.",
      "PRIVATE_MSG_INPUT": "Umschalt + Eingabetaste für neue Zeile. Dies ist nur für Agenten sichtbar",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Die Nachrichtensignatur ist nicht konfiguriert, bitte konfigurieren Sie sie in den Profileinstellungen.",
      "CLICK_HERE": "Klicken Sie hier, um zu aktualisieren",
      "WHATSAPP_TEMPLATES": "WhatsApp-Vorlagen",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "Das 24-Stunden-Fenster von WhatsApp ist abgelaufen. Antworten Sie mit einer Vorlage.",
      "INSERT_SIGNATURE": "Signatur in Editor einfügen",
      "SIGNATURE_PREVIEW_IMAGE": "(Bildsignatur)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Ihre Antwort scheint in {draftLanguage} verfasst zu sein, diese Unterhaltung ist jedoch in {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Übersetzen",
      "REPLY": "Antworten",
      "PRIVATE_NOTE": "Private Notiz",
      "SEND": "Senden",
      "CREATE": "Notiz hinzufügen",
      "INSERT_READ_MORE": "Mehr erfahren",
      "DISMISS_REPLY": "Antwort verwerfen",
      "REPLYING_TO": "Antwort auf:",
      "TIP_FORMAT_ICON": "Rich Text Editor anzeigen",
      "HEADING_LEVEL": {
        "LABEL": "Textstil",
        "NORMAL": "Normaler Text",
        "H1": "Überschrift 1",
        "H2": "Überschrift 2",
        "H3": "Überschrift 3"
      },
      "EDITOR": {
        "BOLD": "Fett",
        "ITALIC": "Kursiv",
        "UNDERLINE": "Unterstrichen",
        "TEXT_COLOR": "Textfarbe",
        "BG_COLOR_LABEL": "Hintergrundfarbe",
        "FONT_SIZE_LABEL": "Schriftgröße",
        "FONT_SIZE": {
          "XS": "Klein",
          "SM": "Mittelklein",
          "MD": "Standard",
          "LG": "Groß",
          "XL": "Sehr groß",
          "XXL": "Riesig"
        },
        "CODE": "Code",
        "LINK": "Link hinzufügen oder entfernen",
        "CREATE_LINK": "Link erstellen",
        "SAVE_LINK": "Speichern",
        "CANCEL": "Abbrechen",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Rückgängig",
        "REDO": "Wiederholen",
        "BULLET_LIST": "Aufzählungsliste",
        "ORDERED_LIST": "Nummerierte Liste",
        "BLOCKQUOTE": "Zitat",
        "H1": "Überschrift 1",
        "H2": "Überschrift 2",
        "H3": "Überschrift 3",
        "IMAGE_UPLOAD": "Bild hochladen",
        "CLEAR_FORMATTING": "Formatierung entfernen",
        "COLOR": {
          "RED": "Rot",
          "YELLOW": "Gelb",
          "BLUE": "Blau",
          "ROSE_RED": "Rosarot",
          "DEEP_CYAN": "Dunkeltürkis",
          "ORANGE": "Orange",
          "PISTACHIO": "Pistazie",
          "PURPLE": "Lila",
          "FUCHSIA": "Fuchsia",
          "SILVER": "Silber",
          "NAVY": "Marineblau",
          "OLD_PINK": "Altrosa",
          "AQUA": "Aquamarin",
          "BROWN": "Braun",
          "OLIVE": "Olivgrün",
          "GOLD": "Gold",
          "BEIGE": "Beige",
          "WINE": "Weinrot",
          "FOREST": "Waldgrün",
          "GREEN": "Grün",
          "BLUE_GREY": "Blaugrau",
          "RUBY_RED": "Rubinrot",
          "CHESTNUT_BROWN": "Kastanienbraun",
          "ASH_GREY": "Aschgrau"
        },
        "BG_COLOR": {
          "RED": "Rot",
          "YELLOW": "Gelb",
          "BLUE": "Blau",
          "ROSE_RED": "Rosarot",
          "DEEP_CYAN": "Dunkeltürkis",
          "ORANGE": "Orange",
          "PISTACHIO": "Pistazie",
          "PURPLE": "Lila",
          "FUCHSIA": "Fuchsia",
          "SILVER": "Silber",
          "NAVY": "Marineblau",
          "OLD_PINK": "Altrosa",
          "AQUA": "Aquamarin",
          "BROWN": "Braun",
          "OLIVE": "Olivgrün",
          "GOLD": "Gold",
          "BEIGE": "Beige",
          "WINE": "Weinrot",
          "FOREST": "Waldgrün",
          "GREEN": "Grün",
          "BLUE_GREY": "Blaugrau",
          "RUBY_RED": "Rubinrot",
          "CHESTNUT_BROWN": "Kastanienbraun",
          "ASH_GREY": "Aschgrau"
        }
      },
      "TIP_EMOJI_ICON": "Emoji-Auswahl anzeigen",
      "TIP_ATTACH_ICON": "Dateien anhängen",
      "TIP_AUDIORECORDER_ICON": "Audio aufzeichnen",
      "TIP_AUDIORECORDER_PERMISSION": "Zugriff auf Audio zulassen",
      "TIP_AUDIORECORDER_ERROR": "Audio konnte nicht geöffnet werden",
      "DRAG_DROP": "Zum Anhängen hierher ziehen und ablegen",
      "START_AUDIO_RECORDING": "Audioaufzeichnung starten",
      "STOP_AUDIO_RECORDING": "Audioaufzeichnung stoppen",
      "": "",
      "EMAIL_HEAD": {
        "TO": "An",
        "ADD_BCC": "BCC hinzufügen",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "E-Mails, durch Kommas getrennt",
          "ERROR": "Bitte geben Sie eine gültige E-Mail-Adresse ein"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "E-Mails, durch Kommas getrennt",
          "ERROR": "Bitte geben Sie eine gültige E-Mail-Adresse ein"
        },
        "EDIT": "Bearbeiten",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Ausblenden",
        "INCLUDE_ORIGINAL_MESSAGE": "Ursprüngliche Nachricht einbeziehen",
        "EDIT_HEADERS": "Bearbeiten",
        "HIDE_HEADER_EDITS": "Änderungen ausblenden",
        "SUBJECT": {
          "LABEL": "BETREFF",
          "PLACEHOLDER": "E-Mail-Betreff",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Undefinierte Variablen",
        "MESSAGE": "Sie haben {undefinedVariablesCount} undefinierte Variablen in Ihrer Nachricht: {undefinedVariables}. Möchten Sie die Nachricht trotzdem senden?",
        "CONFIRM": {
          "YES": "Senden",
          "CANCEL": "Abbrechen"
        }
      },
      "SEND_EMAIL": "E-Mail senden",
      "SEND_SMS": "SMS senden",
      "NO_SMS_INBOX": "Fügen Sie einen SMS-Posteingang hinzu, um SMS-Antworten zu senden.",
      "SEND_CHAT": "Chat senden",
      "REPLY_TO_THIS": "Hierauf antworten",
      "TIP_EXPAND_ICON": "Editor vergrößern",
      "TIP_COLLAPSE_ICON": "Editor verkleinern",
      "COPILOT": {
        "Q": "Roboter um Hilfe fragen"
      }
    },
    "VISIBLE_TO_AGENTS": "Privater Hinweis: Nur für Sie und Ihr Team sichtbar",
    "CHANGE_STATUS": "Gesprächsstatus geändert",
    "CHANGE_STATUS_FAILED": "Änderung des Konversationsstatus fehlgeschlagen",
    "CHANGE_AGENT": "Konversationsempfänger geändert",
    "CHANGE_AGENT_FAILED": "Zuweisungswechsel fehlgeschlagen",
    "ASSIGN_LABEL_SUCCESFUL": "Label erfolgreich zugewiesen",
    "ASSIGN_LABEL_FAILED": "Labelzuweisung fehlgeschlagen",
    "CHANGE_TEAM": "Das Konversationsteam hat sich geändert",
    "FILE_SIZE_LIMIT": "Die Datei überschreitet das Anhangslimit von {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB",
    "MESSAGE_ERROR": "Nachricht konnte nicht gesendet werden, bitte versuchen Sie es später erneut",
    "SENT_BY": "Gesendet von:",
    "BOT": "Bot",
    "SEND_FAILED": "Nachricht konnte nicht gesendet werden! Versuchen Sie es noch einmal",
    "TRY_AGAIN": "neu versuchen",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Agent auswählen",
      "REMOVE": "Entfernen",
      "ASSIGN": "Zuordnen"
    },
    "CONTEXT_MENU": {
      "COPY": "Kopieren",
      "REPLY_TO": "Auf diese Nachricht antworten",
      "DELETE": "Löschen",
      "CREATE_A_CANNED_RESPONSE": "Zu vorgefertigten Antworten hinzufügen",
      "TRANSLATE": "Übersetzen",
      "COPY_PERMALINK": "Link zur Nachricht kopieren",
      "LINK_COPIED": "URL der Nachricht in die Zwischenablage kopiert",
      "DELETE_CONFIRMATION": {
        "TITLE": "Sind Sie sicher, dass Sie diese Nachricht löschen möchten?",
        "MESSAGE": "Sie können diese Aktion nicht rückgängig machen",
        "DELETE": "Löschen",
        "CANCEL": "Abbrechen"
      },
      "FORWARD": "Weiterleiten",
      "FORWARD_ERROR": "Weitergeleitete Nachricht konnte nicht vorbereitet werden"
    },
    "SIDEBAR": {
      "CONTACT": "Kontakt",
      "COPILOT": "Copilot"
    },
    "IMAGE_RESIZE": {
      "SMALL": "Klein",
      "MEDIUM": "Mittel",
      "LARGE": "Groß",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Versteckte Nachrichten anzeigen",
    "TRANSCRIPT": {
      "SHOW": "Vollständiges Transkript anzeigen",
      "HIDE": "Vollständiges Transkript ausblenden",
      "DOWNLOAD": "Transkript herunterladen",
      "COPY": "Transkript kopieren"
    },
    "INVISIBLE_TO_CUSTOMER": "Für den Kunden unsichtbar",
    "SENT_VIA_EMAIL": "Auch per E-Mail an den Kontakt gesendet ({time})",
    "API_HOURS_WINDOW": "Sie können auf diese Unterhaltung nur innerhalb von {hours} Stunden antworten",
    "FACEBOOK_CANNOT_REPLY": "Wenn Sie diese Unterhaltung fortsetzen möchten, ",
    "PENDING_WITH_BOT_BANNER": "Diese Unterhaltung wird vom KI-Bot bearbeitet. Wenn Sie antworten möchten, öffnen Sie die Unterhaltung zuerst.",
    "INBOX_DELETE_REQUESTED_BANNER": "Dieser Posteingang ist zum Löschen markiert, daher würde die Antwort des Kunden nie ankommen. Verschieben Sie die Unterhaltung zum Antworten in einen anderen Posteingang.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Dieser Kontakt hat eine weitere offene Unterhaltung #{id}",
      "MULTIPLE": "Dieser Kontakt hat weitere offene Unterhaltungen ({count})",
      "OPEN": "Öffnen",
      "SHOW": "Anzeigen"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "Dieses Instagram-Konto wurde in den neuen Instagram-Kanal-Posteingang migriert. Alle neuen Nachrichten erscheinen dort. Sie können aus dieser Unterhaltung keine Nachrichten mehr senden.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Nachricht kann nicht gesendet werden, da der Kunde nicht online ist und E-Mail-Continuity nicht verfügbar ist.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "Der Kunde ist nicht online. Möglicherweise erhält er die Nachrichten nicht, da E-Mail-Continuity nicht verfügbar ist.",
    "OPEN_FILE": "Öffnen",
    "DOWNLOAD_ATTACHMENTS": "Alle herunterladen",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Alle Anhänge einzeln herunterladen",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Alle als ZIP herunterladen",
    "ERROR_DOWNLOADING_FILE": "Fehler beim Herunterladen der Datei",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Kunden bitten, ihre WhatsApp-Telefonnummer zu teilen",
      "PENDING_ACTION": "Anfrage nach Kontaktinformationen ausstehend",
      "STATES": {
        "PENDING": "Warten auf Kontaktinformationen",
        "SHARED": "Telefonnummer geteilt",
        "IDENTITY_CONFLICT": "Telefonnummer muss überprüft werden"
      }
    },
    "SLA": {
      "BREACHED": "überschritten"
    },
    "IMAGE_UPLOAD_ERROR": "Bild konnte nicht hochgeladen werden, bitte versuchen Sie es erneut",
    "DRAFT": {
      "FILE_TOO_LARGE": "Datei '{fileName}' ({fileSize}) ist zu groß für die Entwurfsspeicherung und wird übersprungen",
      "ATTACHMENT_SERIALIZATION_FAILED": "Serialisierung des Anhangs für die Entwurfsspeicherung fehlgeschlagen",
      "STORAGE_QUOTA_EXCEEDED": "Speicherkontingent überschritten. Entwurf ohne Anhänge gespeichert",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Entwurf konnte auch ohne Anhänge nicht gespeichert werden",
      "SAVE_FAILED": "Entwurf der Unterhaltung konnte nicht gespeichert werden"
    },
    "COMMENT_TREE": {
      "TITLE": "Kommentarverlauf",
      "EMPTY": "Keine Kommentare vorhanden",
      "VIEW_TREE": "Kommentarverlauf anzeigen"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Das Gespräch wurde von {userName} gelöst",
          "CONTACT_RESOLVED": "Konversation wurde von {contactName} gelöst",
          "OPEN": "Das Gespräch wurde von {userName} wieder eröffnet",
          "PENDING": "Das Gespräch wurde von {userName} als ausstehend markiert",
          "SNOOZED": "Das Gespräch wurde von {userName} zur Erinnerung markiert",
          "AUTO_RESOLVED": "Das Gespräch wurde vom System aufgrund von {duration} Tagen Inaktivität gelöst",
          "SYSTEM_AUTO_OPEN": "Das System hat die Unterhaltung aufgrund einer neuen eingehenden Nachricht wieder geöffnet.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Die Unterhaltung wurde von {userName} als gelöst markiert (ohne CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Die Unterhaltung wurde vom System aufgrund von {duration} Stunden Inaktivität als gelöst markiert",
          "AUTO_RESOLVED_EMPTY": "Die Unterhaltung wurde vom System als gelöst markiert, da sie leer war.",
          "BLOCKED_CONTACT_RESOLVED": "Das System hat die Unterhaltung gelöst, da der Kontakt blockiert ist.",
          "KAUFLAND_TICKET_CLOSED": "Das System hat die Unterhaltung gelöst, da das Ticket auf Kaufland geschlossen wurde."
        },
        "PRIORITY": {
          "ADDED": "{userName} hat die Priorität auf {newPriority} gesetzt",
          "UPDATED": "{userName} hat die Priorität von {oldPriority} zu {newPriority} geändert",
          "REMOVED": "{userName} hat die Priorität entfernt"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} hat sich dieses Gespräch selbst zugewiesen",
          "ASSIGNED": "{userName} von {assigneeName} zugewiesen",
          "REMOVED": "Gespräch nicht zugewiesen von {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Zugewiesen an {teamName} von {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Zugewiesen an {assigneeName} über {teamName} von {userName}",
          "REMOVED": "Entfernt aus {teamName} von {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} hat {labels} hinzugefügt",
          "REMOVED": "{userName} hat {labels} entfernt"
        },
        "SLA": {
          "ADDED": "{userName} hat SLA-Richtlinie {slaName} hinzugefügt",
          "REMOVED": "{userName} hat SLA-Richtlinie {slaName} entfernt",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} hat das Gespräch stumm geschaltet",
        "UNMUTED": "{userName} hat das Gespräch laut gestellt",
        "CONTACT_BLOCKED": "{userName} hat den Kontakt blockiert",
        "CONTACT_UNBLOCKED": "{userName} hat die Blockierung des Kontakts aufgehoben",
        "AUTO_RESOLUTION_MESSAGE": "Die Konversation wird gelöst, da sie seit einiger Zeit inaktiv ist. Bitte beginnen Sie eine neue Konversation, wenn Sie weitere Hilfe benötigen.",
        "DOMAIN_BLOCKED": "{userName} hat alle Kontakte einer bestimmten Domain blockiert",
        "DOMAIN_UNBLOCKED": "{userName} hat alle Kontakte einer bestimmten Domain entsperrt",
        "MERGED": "{userName} hat die Unterhaltung #{sourceId} mit dieser Unterhaltung zusammengeführt",
        "MOVED": "{userName} hat diese Unterhaltung aus dem Posteingang {sourceInboxName} in den Posteingang {targetInboxName} verschoben",
        "MOVED_BY_ORDER": "Verschoben, weil die Bestellungen des Kontakts nur aus dem Shop {storeName} stammen (letzte Bestellung {orderId}), dessen Roboter in diesem Posteingang antwortet.",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Die Aktion zum Senden der Nachricht wurde für diese automatische Antwort übersprungen",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Die Automatisierung wurde übersprungen, da der Kontakt blockiert ist",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Die Automatisierung \"{ruleName}\" konnte diese Unterhaltung nicht vom Posteingang {sourceInboxName} in den Posteingang {targetInboxName} verschieben, da die Posteingänge nicht kompatibel sind.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Die Automatisierung \"{ruleName}\" konnte diese Unterhaltung nicht vom Posteingang {sourceInboxName} in den Posteingang {targetInboxName} verschieben, da der Kontakt keine E-Mail-Adresse hat.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Automatisierung „{ruleName}“ konnte keine Nachricht senden: Dieser Telefon-Posteingang kann keine SMS senden, weil das Konto keinen SMS-Posteingang hat. Die Regel wurde ausgeschaltet und die Administratoren haben eine E-Mail erhalten.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Automatisierung „{ruleName}“ konnte keine Nachricht senden: Aus diesem Posteingang können keine Anhänge per SMS gesendet werden. Die Regel wurde ausgeschaltet und die Administratoren haben eine E-Mail erhalten.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Makro „{macroName}“ hat seine Nachricht nicht gesendet: Dieser Telefon-Posteingang kann keine SMS senden, weil das Konto keinen SMS-Posteingang hat.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Makro „{macroName}“ hat seine Nachricht nicht gesendet: Aus diesem Posteingang können keine Anhänge per SMS gesendet werden.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Makro „{macroName}“ hat seine Nachricht nicht gesendet: Der Bot bearbeitet diese Unterhaltung. Öffnen Sie zuerst die Unterhaltung.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Makro „{macroName}“ hat seine Nachricht nicht gesendet: Dieser Posteingang ist zum Löschen markiert. Verschieben Sie die Unterhaltung zuerst in einen anderen Posteingang.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Die Automatisierung \"{ruleName}\" hat {contactEmail} in einer neuen Unterhaltung [#{conversationId}]({conversationPath}) im Posteingang {inboxName} eine E-Mail gesendet.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Die Automatisierung \"{ruleName}\" hat diese Unterhaltung wegen der Unterhaltung [#{conversationId}]({conversationPath}) im Posteingang {inboxName} gestartet.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Die Automatisierung \"{ruleName}\" konnte die Nachricht nicht in einer neuen Unterhaltung im Posteingang {inboxName} senden, da der Kontakt keine E-Mail-Adresse hat.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Die Automatisierung \"{ruleName}\" hat an {contactPhone} in einer neuen Unterhaltung [#{conversationId}]({conversationPath}) im Posteingang {inboxName} eine SMS gesendet.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Die Automatisierung \"{ruleName}\" konnte die SMS nicht in einer neuen Unterhaltung im Posteingang {inboxName} senden, da der Kontakt keine Telefonnummer hat.",
        "AUTOMATION_RULE_TRIGGERED": "Automatisierungsregel \"{ruleName}\" wurde ausgelöst",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automatisierungsregel \"{ruleName}\" hat die automatische Priorisierung deaktiviert",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automatisierungsregel \"{ruleName}\" hat die automatische Labelvergabe deaktiviert",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automatisierungsregel \"{ruleName}\" hat die weitere Regelverarbeitung gestoppt",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Agent",
            "CUSTOMER": "Kunde"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "anderswo angenommen, {duration} geklingelt",
            "NO_ANSWER": "nicht angenommen, {duration} geklingelt",
            "REJECTED": "abgelehnt nach {duration} Klingeln"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Automatisch gelöst nach {count} erfolglosen Rückrufen",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Anrufaufzeichnung gelöscht von {name}, {date}"
        }
      }
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Konversations-Transkript senden",
    "DESC": "Kopie des Konversationsprotokolls an die angegebene E-Mail-Adresse senden",
    "SUBMIT": "Speichern",
    "CANCEL": "Abbrechen",
    "SEND_EMAIL_SUCCESS": "Das Chat-Protokoll wurde erfolgreich gesendet",
    "SEND_EMAIL_ERROR": "Es ist ein Fehler aufgetreten, bitte versuchen Sie es erneut",
    "FORM": {
      "SEND_TO_CONTACT": "Das Transkript an den Kunden senden",
      "SEND_TO_AGENT": "Transkript an den zugewiesenen Agenten senden",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Transkript an eine andere E-Mail-Adresse senden",
      "EMAIL": {
        "PLACEHOLDER": "E-Mail-Adresse eingeben",
        "ERROR": "Bitte geben Sie eine gültige E-Mail-Adresse ein"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Hallo 👋, Willkommen bei {installationName}!",
    "DESCRIPTION": "Danke für's Registrieren. Wir möchten, dass Sie {installationName} optimal nutzen. Hier sind ein paar Dinge, die Sie in {installationName} tun können, um das Erlebnis angenehm zu gestalten.",
    "GREETING_MORNING": "👋 Guten Morgen, {name}. Willkommen bei {installationName}.",
    "GREETING_AFTERNOON": "👋 Guten Nachmittag, {name}. Willkommen bei {installationName}.",
    "GREETING_EVENING": "👋 Guten Abend, {name}. Willkommen bei {installationName}.",
    "READ_LATEST_UPDATES": "Lesen Sie unsere neuesten Updates",
    "ALL_CONVERSATION": {
      "TITLE": "All Ihre Konversationen an einem Ort",
      "DESCRIPTION": "Zeigen Sie alle Konversationen Ihrer Kunden in einem einzigen Dashboard an. Sie können die Konversationen nach eingehendem Kanal, Bezeichnung und Status filtern.",
      "NEW_LINK": "Hier klicken, um einen Posteingang zu erstellen"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Laden Sie Ihre Teammitglieder ein",
      "DESCRIPTION": "Da Sie sich darauf vorbereiten, mit Ihrem Kunden zu sprechen, ziehen Sie Ihre Teamkollegen hinzu, um Ihnen zu helfen. Sie können Ihre Teamkollegen einladen, indem Sie deren E-Mail-Adressen zur Agentenliste hinzufügen.",
      "NEW_LINK": "Klicken Sie hier, um ein Teammitglied einzuladen"
    },
    "LABELS": {
      "TITLE": "Organisieren Sie Konversationen mit Labels",
      "DESCRIPTION": "Labels bieten eine einfachere Möglichkeit, Ihre Konversation zu kategorisieren. Erstellen Sie einige Labels wie #support-enquiry, #billing-quest etc., damit Sie sie später in einem Gespräch verwenden können.",
      "NEW_LINK": "Hier klicken, um Tags zu erstellen"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Vorgefertigte Antworten erstellen",
      "DESCRIPTION": "Vorgefertigte Schnellantwortvorlagen helfen Ihnen, schnell auf eine Konversation zu antworten. Agenten können das Zeichen '/' gefolgt vom Short-Code eingeben, um eine Antwort einzufügen.",
      "NEW_LINK": "Hier klicken, um eine vorgefertigte Antwort zu erstellen"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Zugewiesener Agent",
    "SELF_ASSIGN": "Mir zuweisen",
    "TEAM_LABEL": "Zugewiesenes Team",
    "SELECT": {
      "PLACEHOLDER": "Keine"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Benutzerdefinierte Daten",
      "CONTACT_DETAILS": "Kontakt-Details",
      "CONVERSATION_ACTIONS": "Konversationsaktionen",
      "CONVERSATION_LABELS": "Konversationslabels",
      "CONVERSATION_INFO": "Konversationsinformationen",
      "CONTACT_ATTRIBUTES": "Kontakt-Attribute",
      "PREVIOUS_CONVERSATION": "Vorherige Konversationen",
      "MACROS": "Makros",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Bestellverlauf",
      "RETINO_TICKETS": "Retino-Tickets"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Ausstehend",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Attribut erstellen",
    "NO_RECORDS_FOUND": "Keine Attribute gefunden",
    "UPDATE": {
      "SUCCESS": "Attribut erfolgreich aktualisiert",
      "ERROR": "Attribut kann nicht aktualisiert werden. Bitte versuchen Sie es später noch einmal"
    },
    "ADD": {
      "TITLE": "Hinzufügen",
      "SUCCESS": "Attribut erfolgreich hinzugefügt",
      "ERROR": "Attribut kann nicht hinzugefügt werden. Bitte versuchen Sie es später noch einmal"
    },
    "DELETE": {
      "SUCCESS": "Attribut erfolgreich gelöscht",
      "ERROR": "Attribut kann nicht gelöscht werden. Bitte versuchen Sie es später noch einmal"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Attribute hinzufügen",
      "PLACEHOLDER": "Attribut suchen",
      "NO_RESULT": "Keine Attribute gefunden"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Von",
    "TO": "An",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Betreff"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Zugewiesen",
    "SIDEBAR_TITLE": "Konversationsteilnehmer",
    "NO_RECORDS_FOUND": "Keine Ergebnisse gefunden",
    "ADD_PARTICIPANTS": "Teilnehmer wählen",
    "REMANING_PARTICIPANTS_TEXT": "+{count} andere",
    "REMANING_PARTICIPANT_TEXT": "+{count} andere",
    "TOTAL_PARTICIPANTS_TEXT": "{count} Personen nehmen teil.",
    "TOTAL_PARTICIPANT_TEXT": "{count} Person nimmt teil.",
    "NO_PARTICIPANTS_TEXT": "Niemand nimmt teil!.",
    "WATCH_CONVERSATION": "Konversation beitreten",
    "YOU_ARE_WATCHING": "Sie nehmen teil",
    "API": {
      "ERROR_MESSAGE": "Konnte nicht aktualisiert werden, versuchen Sie es noch einmal!",
      "SUCCESS_MESSAGE": "Teilnehmer aktualisiert!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Übersetzten Inhalt anzeigen",
    "DESC": "Sie können den übersetzten Inhalt in jeder Sprache ansehen.",
    "ORIGINAL_CONTENT": "Originalinhalt",
    "TRANSLATED_CONTENT": "Übersetzter Inhalt",
    "NO_TRANSLATIONS_AVAILABLE": "Für diesen Inhalt sind keine Übersetzungen verfügbar"
  },
  "TYPING": {
    "ONE": "{user} tippt",
    "TWO": "{user} und {secondUser} tippen",
    "MULTIPLE": "{user} und {count} andere tippen",
    "IMAGE_ALT": "Jemand tippt"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Probiere diese Prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Anhang konnte nicht heruntergeladen werden. Bitte versuche es erneut"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "Keine Daten gefunden",
    "LOAD_ERROR": "Daten konnten nicht geladen werden. Bitte versuchen Sie es später erneut."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Mehr laden",
    "NO_RECORDS_FOUND": "Keine Tickets gefunden",
    "LOAD_ERROR": "Tickets von {hookName} konnten nicht geladen werden. Bitte versuchen Sie es später erneut.",
    "NOT_SEARCHABLE": "Kontakt-E-Mail ist nicht gesetzt.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Wird geladen...",
    "NO_ORDERS": "Keine Bestellungen gefunden",
    "NOT_AVAILABLE": "Kundendaten nicht verfügbar",
    "EXPAND": "Kundenprofil öffnen",
    "MORE_ITEMS": "+ {count} Elemente",
    "EXPEDITION_STATUS": "Versandstatus",
    "OPEN_DETAIL": "Detail öffnen",
    "COPY_ORDER_ID": "Bestellnummer",
    "EXTERNAL_ID": "Externe ID",
    "PAYMENT_TYPE": "Zahlungsart",
    "PAYMENT_DATE": "Zahlungsdatum",
    "DELIVERY_PROVIDER": "Versanddienstleister",
    "EXPECTED_DATE_OF_DELIVERY": "Voraussichtliche Lieferung",
    "DATE_OF_DELIVERY": "Geliefert am",
    "EXPEDITION_DATE": "Versanddatum",
    "INTERNAL_NOTE": "Shop-Notiz",
    "PACKAGE_NUMBER": "Sendung"
  },
  "READING": {
    "ONE": "{user} liest dieses Ticket",
    "TWO": "{user} und {secondUser} lesen dieses Ticket",
    "MULTIPLE": "{user} und {count} weitere lesen dieses Ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Unterhaltung verschieben",
    "DESCRIPTION": "Diese Unterhaltung in einen anderen E-Mail-Posteingang verschieben.",
    "SOURCE": {
      "TITLE": "Unterhaltung",
      "ID_LABEL": "Unterhaltungs-ID"
    },
    "TARGET": {
      "TITLE": "Ziel-Posteingang",
      "PLACEHOLDER": "Einen E-Mail-Posteingang auswählen",
      "NO_RESULTS": "Keine weiteren E-Mail-Posteingänge verfügbar",
      "ERROR": "Bitte wählen Sie einen Ziel-Posteingang aus"
    },
    "SUBMIT": "Unterhaltung verschieben",
    "CANCEL": "Abbrechen",
    "SUCCESS_MESSAGE": "Unterhaltung erfolgreich verschoben",
    "ERROR_MESSAGE": "Unterhaltung konnte nicht verschoben werden. Bitte versuchen Sie es erneut."
  },
  "MERGE": {
    "TITLE": "Unterhaltungen zusammenführen",
    "DESCRIPTION": "Diese Unterhaltung mit einer anderen zusammenführen. Alle Nachrichten dieser Unterhaltung werden in die Zielunterhaltung verschoben und diese Unterhaltung wird gelöscht.",
    "SOURCE": {
      "TITLE": "Quellunterhaltung (wird gelöscht)",
      "ID_LABEL": "Unterhaltungs-ID"
    },
    "TARGET": {
      "TITLE": "Zielunterhaltung",
      "PLACEHOLDER": "Unterhaltungs-ID zur Suche eingeben (z. B. 123)",
      "HELP": "Geben Sie die ID der Unterhaltung ein, in die alle Nachrichten zusammengeführt werden sollen.",
      "ERROR": "Bitte wählen Sie eine Zielunterhaltung aus"
    },
    "WARNING": "Warnung: Diese Aktion kann nicht rückgängig gemacht werden. Alle Nachrichten werden in die Zielunterhaltung verschoben und diese Unterhaltung wird dauerhaft gelöscht.",
    "SUBMIT": "Unterhaltungen zusammenführen",
    "CANCEL": "Abbrechen",
    "SUCCESS_MESSAGE": "Unterhaltung erfolgreich zusammengeführt",
    "ERROR_MESSAGE": "Unterhaltungen konnten nicht zusammengeführt werden. Bitte prüfen Sie die Zielunterhaltung und versuchen Sie es erneut.",
    "SEARCH": {
      "NO_RESULTS": "Keine Unterhaltung mit dieser ID gefunden",
      "ERROR_MESSAGE": "Unterhaltungen konnten nicht durchsucht werden. Bitte versuchen Sie es erneut."
    },
    "CONFIRM": {
      "TITLE": "Zusammenführung bestätigen",
      "DESCRIPTION": "Sind Sie sicher, dass Sie diese Unterhaltung zusammenführen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
      "YES": "Ja, zusammenführen",
      "CANCEL": "Abbrechen"
    }
  }
}
